import userService from "@/app/services/main/user/user-service.js";
import DatePicker from 'vue2-datepicker';

// Components
const UserPetsComponent = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "user-pets-component"*/ "@/app/views/main-view/users/components/user-pet-component/user-pet-component.vue"
    );
const ModalUpdateStoreCredit = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "modal-update-store-credit"*/ "@/app/views/main-view/users/components/modals/modal-update-store-credit/modal-update-store-credit.vue"
    );
const OrdersTable = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "orders-table"*/ "@/app/views/main-view/orders/containers/orders-table/orders-table.vue"
    );
const BreedTableComponentList = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "breed-table-component"*/ "@/app/views/main-view/_shared/_components/breed-table-component-list/breed-table-component-list.vue"
    )
const WalkerSitterComponent = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "walker-sitter-component"*/ "@/app/views/main-view/users/components/walker-sitter-component/walker-sitter-component.vue"
    )
// Mixins
import { mobileNumberMixins } from "@/app/mixins/utils/mobile-number-mixins.js";
import { tableMixins } from "@/app/mixins/utils/table-mixins"
import { dateMixins } from "@/app/mixins/utils/date-mixins"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";
import { vuelidateUtil } from '@/utils/vuelidate-util';

// Constants
import { STATUS_CODES, USER_TYPE, USER_ROLE, SUCCESS_MSG } from "@/app/constants/constants";

// Events
import EventBus from "@/app/bus/event-bus.js";

export default {
    name: "UserViewComponent",
    components: {
        UserPetsComponent,
        ModalUpdateStoreCredit,
        OrdersTable,
        BreedTableComponentList,
        WalkerSitterComponent,
        DatePicker,
    },
    mixins: [mobileNumberMixins, tableMixins, dateMixins, toastMessageMixins],
    data() {
        return {
            userId: null,
            isAPILoading: true,
            userDetails: {},
            userWalkerSitterDetails: {},
            hasWalkerSitter: false,
            petOwnerFilter: "",
            modalContent: {},
            backButtonLabel: 'BACK TO USERS AND ADMIN',
            prevRouteTo: '/users',

            storeCreditNote: "",
            storeCreditNotes: [],
            isStoreCreditNotesCollapsed: true,

            userNote: "",
            userNoteReminderList: [],
            showDatepicker: false,
            notifyDate: null,
            isNotesAndRemindersCollapsed: true,
            isAddingNoteAndReminder: false,
        };
    },
    async created() {
        this.userId = this.$route.params.id;
        console.log(`this.$route.query.actionFrom ====> `, this.$route.query.actionFrom)
        if(this.$route.query.actionFrom === 'store-credit-balance') {
            this.backButtonLabel = 'BACK TO STORE CREDIT BALANCE'
            this.prevRouteTo = '/users/store-credit-list'
        } else if(this.$route.query.actionFrom === 'user-subscription') {
            this.backButtonLabel = 'BACK TO SUBSCRIPTIONS'
            this.prevRouteTo = '/subscriptions'
        }
        this.getUserDetails();
        this.getUserWalkerSitterDetails()
        await this.getUserNotesAndReminders();
        await this.getUserStoreCreditHistory();

        if (this.notifyDate !== null) {
            this.showDatepicker = true;
        }

    },
    computed:{
        displayWalkerSitterDetails(){
            if(!this.userDetails.code){
                return false;
            }

            const wasiRoles = [USER_ROLE.WALK, USER_ROLE.SITT, USER_ROLE.WASI];
            return wasiRoles.includes(this.userDetails.code);
        },

        validationRules() {
            let fields = {
                userNote: {},
                notifyDate: {}
            }

            fields = vuelidateUtil.setFieldsRequired(fields, true);
            return fields;
        },

        disableAddNote() {
            if (this.userNoteReminderList.length === 0) {
                return false;
            }

            if (!this.userNote || this.userNote.trim() === "") {
                return true;
            }

            const { reminderNote, reminderDate } = this.userNoteReminderList[0];
            const formatDate = this.notifyDate ? this.formatDate(new Date(this.notifyDate)) : null;

            if (reminderNote === this.userNote && reminderDate === formatDate) {
                return true;
            }

            return false;

        },
        
    },
    methods: {
        sortAvailableDate(daysOfWeek) {
            let weekdays = this.convertToFullNames(daysOfWeek);
            const weekdaysOrder = {
                "Monday": 0,
                "Tuesday": 1,
                "Wednesday": 2,
                "Thursday": 3,
                "Friday": 4,
                "Saturday": 5,
                "Sunday": 6
              };
              
              // Custom sorting function based on weekdaysOrder
              weekdays.sort((a, b) => {
                return weekdaysOrder[a] - weekdaysOrder[b];
              });
           return weekdays.join(', ');
        },

        convertToFullNames(abbreviatedArray) {
            const dayOfWeek = {
                MON: 'Monday',
                TUE: 'Tuesday',
                WED: 'Wednesday',
                THU: 'Thursday',
                FRI: 'Friday',
                SAT: 'Saturday',
                SUN: 'Sunday'
              };
              return abbreviatedArray.map(day => dayOfWeek[day] || day);
        },

        handleSubPreFilter({ owner, petName }) {
            const data = {
                emailAddress: owner,
                petName,
            };
            this.$store.commit("setSubscriptionPreFilterMode", true);
            this.$store.commit("setFromUsersFilter", data);
            EventBus.$emit("subscriptions", data);
            this.$router.push("/subscriptions");
        },
        handleTreatPreFilter({ owner, petName }) {
            const data = {
                emailAddress: owner,
                petName,
            };
            this.$store.commit("setTreatmentPreFilterMode", true);
            this.$store.commit("setFromUsersFilter", data);
            EventBus.$emit("treatments", data);
            this.$router.push("/treatments");
        },
        handleOrdersPreFilter({ owner, petName }) {
            const data = {
                emailAddress: owner,
                petName,
                owner: `${this.userDetails.firstName} ${this.userDetails.lastName}`,
            };
            this.$store.commit("setOrdersPreFilterMode", true);
            this.$store.commit("setFromUsersFilter", data);
            EventBus.$emit("orders", data);
            this.$router.push("/orders");
        },
        getUserDetails() {
            this.isAPILoading = true;
            userService.getUserDetails(this.userId).then((res) => {
                if (res.status === STATUS_CODES.SUCCESS) {
                    this.userDetails = res.data;

                    this.isAPILoading = false;
                } else {
                    this.showAPIErrorToast("Unable to fetch user details.", res);
                }
            });
        },
        async getUserNotesAndReminders() {

            this.isAPILoading = true;

            try {
                const response = await userService.getUserNotesAndReminders(this.userId);
                if (response.status === STATUS_CODES.SUCCESS) {
                    this.userNote = response.data[0] ? response.data[0].reminderNote : null;
                    this.notifyDate = response.data[0] ? new Date(response.data[0].reminderDate) : null;
                    this.userNoteReminderList = response.data.map((note) => {
                        return {
                            ...note,
                            reminderNote: note.reminderNote,
                            reminderDate: note.reminderDate ? this.formatDateTime(note.reminderDate, "dd-MMM-yyyy") : null,
                        };
                    });
                }

            } catch (err) {
                this.showAPIErrorToast("Unable to fetch user notes and reminders.", err);
            } finally {
                this.isAPILoading = false;
            }

        },
        async getUserStoreCreditHistory() {
            try{
                this.isAPILoading = true;
                const response = await userService.getUserStoreCreditHistory(this.userId);
                if (response.status === STATUS_CODES.SUCCESS) {
                    this.storeCreditNotes = response.data;

                    if(this.storeCreditNotes && this.storeCreditNotes.length > 0){
                        this.storeCreditNote = this.storeCreditNotes[0];
                    }
                } else {
                    this.showAPIErrorToast("Unable to fetch user store credit history.", response);
                }
            } catch(err){
                this.showGenericErrorToast();
            } finally{
                this.isAPILoading = false;
            }         
        },
        async getUserDetailsAndStoreCreditHistory(){
            this.getUserDetails();
            await this.getUserStoreCreditHistory();
        },
        getUserWalkerSitterDetails() {
            this.isAPILoading = true;
            userService.getUserWalkerSitterDetails(this.userId).then((res) => {
                if (res.status === STATUS_CODES.SUCCESS) {
                    this.userWalkerSitterDetails = res.data;
                    this.isAPILoading = false;
                    this.hasWalkerSitter = true;
                } else if (res.status === STATUS_CODES.NOT_FOUND) {
                    this.hasWalkerSitter = false;
                    this.isAPILoading = false;
                } else {
                    this.showAPIErrorToast("Unable to fetch user details.", res);
                }
            });
        },
        handleClearPetOwnerFilter() {
            this.petOwnerFilter = "";
        },
        showUpdateStoreCreditModal() {
            this.modalContent = this.userDetails;
            this.$refs.modalUpdateStoreCredit.show();
        },
        userInfo(info) {
            const { isPrimaryUser, code } = info;

            let details = isPrimaryUser ? "Primary" : "Secondary";

            return `(${details} - ${USER_TYPE[code]})`;
        },
        formatAmount(num){
            if(!num || isNaN(num)){
                return 0;
            }

            return parseFloat(num).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        async onAddNoteAndReminder() {
            this.$v.$touch();

            this.isAddingNoteAndReminder = true;
            let noteReminderDetails = {}

            if (!this.userNote || (this.showDatepicker && !this.notifyDate)) return;

            if (this.userNote) {
                noteReminderDetails.reminderNote = this.userNote;
            }

            if (this.notifyDate && this.showDatepicker) {
                noteReminderDetails.reminderDate = this.dateToISO(this.notifyDate);
            }

            try {
                const result = await userService.addUserNoteAndReminder(this.userId, noteReminderDetails)

                if (result.status === STATUS_CODES.SUCCESS) {
                    this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, this.toastMessages.noteReminder().SUCCESS_ADD_NOTE_REMINDER);
                    this.getUserNotesAndReminders();
                } else {
                    this.showAPIErrorToast("Unable to add note and reminder.", res);
                }

            } catch (err) {
                this.showGenericErrorToast();
            } finally {
                this.isAddingNoteAndReminder = false;
            }


        },
        onNotifyToggle() {
            this.notifyDate = null;
            this.$v.notifyDate.$reset();
        },
        disablePastDates(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return date <= today;
        }


    },
    validations() {
        return this.validationRules;
    }
};
